var _clipPath, _clipPath2, _clipPath3, _clipPath4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCelcom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 299.99999 151.209",
    height: 151.209,
    width: 300,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath32",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "m 501.646,330.326 21.738,-12.537 0,25.073 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient48",
    spreadMethod: "pad",
    gradientTransform: "matrix(21.734039,0,0,21.734039,501.64063,330.31934)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop38",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#2d2a62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop40",
    offset: 0.16096968,
    style: {
      stopOpacity: 1,
      stopColor: "#5e246a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop42",
    offset: 0.2,
    style: {
      stopOpacity: 1,
      stopColor: "#5e246a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    offset: 0.20348079,
    style: {
      stopOpacity: 1,
      stopColor: "#5e246a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#b9367a"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath58",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 501.646,330.326 21.738,12.536 -21.738,12.566 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient72",
    spreadMethod: "pad",
    gradientTransform: "matrix(-1.7e-6,-25.098097,25.098097,-1.7e-6,512.51562,355.42871)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop64",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#e64114"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop66",
    offset: 0.1,
    style: {
      stopOpacity: 1,
      stopColor: "#e64114"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop68",
    offset: 0.87593565,
    style: {
      stopOpacity: 1,
      stopColor: "#f29200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop70",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#f29200"
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath82",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "m 501.646,305.245 21.738,12.544 -21.738,12.537 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient96",
    spreadMethod: "pad",
    gradientTransform: "matrix(21.734039,0,0,21.734039,501.64063,317.78027)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop88",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#b1243f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop90",
    offset: 0.05,
    style: {
      stopOpacity: 1,
      stopColor: "#b1243f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop92",
    offset: 0.63839924,
    style: {
      stopOpacity: 1,
      stopColor: "#e40052"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop94",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#e40052"
    }
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath106",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "m 0,595.28 841.89,0 L 841.89,0 0,0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,151.209)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4265",
    transform: "matrix(1.1097482,0,0,1.1097496,-355.82445,-294.93072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4242"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.9219,317.7896)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#e73378",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 21.724,-12.544 0,25.079 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(479.9219,367.9546)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#fab91c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-25.092 21.724,12.565 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.6455,355.4277)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#f29200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -21.724,-12.565 0,-25.102 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath32)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "url(#linearGradient48)",
      stroke: "none"
    },
    d: "m 501.646,330.326 21.738,-12.537 0,25.073 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath58)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "url(#linearGradient72)",
      stroke: "none"
    },
    d: "m 501.646,330.326 21.738,12.536 -21.738,12.566 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath82)",
    id: "g78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "url(#linearGradient96)",
      stroke: "none"
    },
    d: "m 501.646,305.245 21.738,12.544 -21.738,12.537 z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g102",
    clipPath: "url(#clipPath106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4224"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.1958,282.9883)",
    id: "g108",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.315,3.917 3.048,6.628 6.368,6.628 3.817,0 6.002,-2.659 6.331,-6.628 z m 6.262,12.758 c -8.762,0 -14.163,-6.439 -14.163,-15.052 0.117,-9.52 6.763,-14.931 14.723,-14.931 3.698,0 7.12,0.71 9.578,2.146 0.831,0.475 0.917,1.227 0.917,2.051 l 0,3.875 c -2.606,-1.248 -5.435,-1.957 -7.997,-1.957 -4.368,0 -8.284,1.897 -9.156,6.307 l 20.15,0 c 0.115,0.932 0.115,1.374 0.115,2.027 -0.061,8.715 -4.618,15.534 -14.167,15.534"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.4277,272.1885)",
    id: "g112",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.473,0 -8.061,3.891 -8.061,8.679 0,4.899 3.396,8.335 7.95,8.335 4.535,0 8.124,-3.659 8.124,-8.577 C 8.013,3.607 4.695,0 0,0 m 0,23.558 c -8.765,0 -15.523,-6.593 -15.523,-15.121 0,-8.437 6.658,-14.861 15.412,-14.861 8.822,0 15.757,6.544 15.757,15.103 0,8.502 -6.827,14.879 -15.646,14.879"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.8145,295.7461)",
    id: "g116",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.849,0 -7.207,-1.658 -9.097,-4.16 -1.955,2.502 -5.292,4.16 -9.217,4.16 -2.927,0 -6.094,-1.389 -7.516,-3.506 l 0,3.592 c -1.296,-0.147 -4.355,-0.491 -6.245,-2.276 -0.776,-0.758 -1.032,-1.634 -1.032,-2.673 l 0,-24.459 7.277,0 0,18.469 c 0,2.462 2.458,4.358 5.566,4.358 1.418,0 2.671,-0.323 3.592,-0.92 1.149,-0.758 1.913,-1.857 1.913,-3.81 l 0,-18.097 7.183,0 0,18.469 c 0,2.462 2.461,4.358 5.565,4.358 1.416,0 2.667,-0.323 3.591,-0.92 1.151,-0.758 1.891,-1.857 1.891,-3.81 l 0,-18.097 7.36,0 0,20.705 C 10.831,-3.78 6.051,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408.7861,288.7207)",
    id: "g120",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.722,0 4.674,-0.852 6.861,-2.741 l 4.69,5.019 C 8.596,5.258 5.164,7.025 0.107,7.025 c -8.941,0 -15.264,-6.783 -15.264,-14.827 0,-9.806 6.882,-15.155 14.881,-15.155 3.707,0 7.08,0.71 9.528,2.145 0.825,0.474 0.932,1.227 0.932,2.049 l 0,3.999 c -2.615,-1.266 -5.394,-1.978 -7.955,-1.978 -5.16,0 -9.309,2.68 -9.309,8.94 C -7.08,-3.443 -4.095,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.8115,300.355)",
    id: "g124",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 0,-33.931 7.41,0 0,39.766 C 6.605,5.631 2.988,4.744 1.102,2.788 0.325,2.021 0,0.933 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504.458,294.998)",
    id: "g128",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -1.328,0 0,0.511 3.189,0 0,-0.511 -1.307,0 0,-3.631 -0.554,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(506.9043,295.5088)",
    id: "g132",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 1.005,0 2.289,-3.428 3.574,0 l 0.988,0 0,-4.14 -0.586,0 0,3.605 -0.038,0 -1.405,-3.605 -0.555,0 -1.381,3.605 -0.031,0 0,-3.605 -0.566,0 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.7793,288.7207)",
    id: "g136",
    style: {
      fill: "#0075b9",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#0075b9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 2.729,0 4.692,-0.849 6.872,-2.741 L 11.561,2.27 C 8.618,5.258 5.194,7.025 0.122,7.025 c -8.948,0 -15.266,-6.783 -15.266,-14.827 0,-9.809 6.872,-15.155 14.876,-15.155 3.702,0 7.08,0.699 9.543,2.138 0.818,0.476 0.925,1.228 0.925,2.054 l 0,3.992 c -2.629,-1.267 -5.378,-1.969 -7.958,-1.969 -5.165,0 -9.332,2.671 -9.332,8.94 C -7.09,-3.443 -4.072,0 0,0"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelcom);
export default __webpack_public_path__ + "static/media/celcom.751b233595b6cfcd82fd463a7d4ad35a.svg";
export { ForwardRef as ReactComponent };